import { FC, ReactNode } from "react";
import { SwiperSlide } from "swiper/react";

const CarouselItem: FC<{ children?: ReactNode }> = ({ children }) => {
  return <SwiperSlide>{children}</SwiperSlide>;
};

CarouselItem.displayName = "SwiperSlide";

export default CarouselItem;
